import React, { useState, useEffect, useRef, useMemo } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton, Stack, Typography } from '@mui/material';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';

export default function ScrollDialog(props) {

  const showCloseIcon = useMemo(() => props.showCloseIcon || false,[props.showCloseIcon]);
  const disableDialogActions = useMemo(() => props.disableDialogActions || false,[props.disableDialogActions]);
  const showApplyButton = useMemo(() => (typeof props.onApplyButtonClick === 'function' || props.showApplyButton || false),[props.showApplyButton, props.onApplyButtonClick]);
  const applyButtonLabel = useMemo(() => props.applyButtonLabel || 'Apply',[props.applyButtonLabel]);
  const [open, setOpen] = useState(false);
  const [scroll] = useState('paper');
  const dialogRef = useRef(null);

  const handleClose = (_, reason) => {
    if(reason === 'backdropClick' && props?.preventBackdropClickClose) {
      return;
    }
    if(props?.onModalClose){
      props.onModalClose();
    }
    setOpen(false);
  };

  const handleApplyBtnClick = () => {
    if(props?.onApplyButtonClick){
      props.onApplyButtonClick();
    }
  };

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  useEffect(() => {
    if(props.open !== open){
      setOpen(props.open);
    }
  }, [props.open, setOpen, open]);

  return (
    <Dialog
      fullWidth={ typeof props?.fullWidth === 'boolean' ? props.fullWidth: !(props?.isFullScreen)}
      fullScreen={(props?.isFullScreen) || false}
      maxWidth={ props.maxWidth || "sm"}
      disableEscapeKeyDown={props?.disableEscapeKeyDown || false}
      open={open}
      onClose={handleClose}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      ref={dialogRef}
      sx={{'.MuiDialog-paper': {borderRadius: {xs: props?.isFullScreen ? 0 : 4, sm: 4}}}}
    >
      <DialogTitle id="scroll-dialog-title">
        {(props?.isFullScreen || props.title) ? (
          <Stack direction="row" alignItems="center">
            {(props?.isFullScreen) ? <IconButton  onClick={handleClose}><ArrowBackIosNewRoundedIcon /></IconButton> : null}
            {props.title ? <Typography variant='h6' fontWeight={400} fontSize='1.2rem'>{props.title}</Typography> :''}
          </Stack>
        ) : null}
        {props.caption? <Typography sx={{px: props?.isFullScreen ? 1: 0}} display="block" variant="caption" color="textSecondary">{props.caption}</Typography> : null}
       {showCloseIcon ? (<IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>):null}
      </DialogTitle>
      <DialogContent dividers={scroll !== 'paper'}>
        {/* <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        > */}
          {/* {props.children} */}
          {React.cloneElement(props.children, { handleClose, dialogRef })}
        {/* </DialogContentText> */}
      </DialogContent>
      {disableDialogActions === true ? null :(<DialogActions sx={{my: 1, mx: 1}}>
        <Button color="secondary" onClick={handleClose}>Close</Button>
        {showApplyButton ? <Button variant="tonal" color="secondary" onClick={handleApplyBtnClick}>{applyButtonLabel}</Button> : null}
      </DialogActions>)}
    </Dialog>
  );
}
